const MOBILE_FADE_IN_KEYFRAMES = {
    from: { opacity: 0, transform: 'translateY(6px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
};

export default MOBILE_FADE_IN_KEYFRAMES;
